<div class="Popup popup-inner-space">

  <div class="row justify-content-between">
    <div class="col-lg-10">
      <p class="popup-heading file-heading">File Upload</p>
    </div>
    <div class="clsicon text-right col-lg-2"><img src="assets/images/close.svg" alt="..."
        class="img-fluid closeicon2 cursor-pointer" (click)="Close()"></div>
  </div>
  <div class="form-group row marginrightleft10" style="display:block" *ngIf="DisplayMsg">
    <p>Please wait for some time for order generation...</p>
  </div>

</div>
<div class="errmsg11 fileuploadsucess" *ngIf="errorMsg">
  {{errorMsg}}
</div>
<div class="sucessmsg fileuploadsucess" *ngIf="successMsg">{{successMsg}}</div>
<div class="Uploadsection">
  <table class="table table-bordered" id="tablefileUploadfliestbl">
    <thead id="theadfileUploadfliestbl">
      <tr id="trfileUploadfliestbl">
        <th id="thfileUploadFilName" class="filenames">File Name</th>
        <th id="thfileUploadSize" class="progress-size">Size</th>
        <th *ngIf="!IsFromMain" id="thfileUploadProgress" class="progress-size">Progress</th>
      </tr>
    </thead>
    <tbody id="tbodyfileUploadfliestbl">
      <tr *ngFor="let file of files" id="trodyfileUploadfliestbldata">
        <td id="tdfileUploadfilename">{{file.name}}</td>
        <td id="tdfileUploadstrsize">{{file.strsize}}</td>
        <td id="tdfileUploadComplete">
          <span *ngIf="!IsFromMain">{{progress}}% Complete</span>
          <button class="Upload-data selectfile" (click)="OnClick()" id="btnfileUploadfileupload">{{btnName}}</button>
        </td>
      </tr>
    </tbody>
  </table>
  <div id="upload_button">
    <label class="selectupload" id="lblfileUploadChse">

      <input id="txtfileUploadfilename" #file type="file" class="choosefile" multiple
        (change)="IsFromMain?onFileChange($event):upload($event)"
        accept="{{IsFromMain ? '.xls,.xlsx,.csv,' : '.jpg,.png,.jpeg'}}" />
      <!-- <input id="txtfileUploadfilename" #file type="file" class="choosefile" multiple
        (change)="IsFromMain?onFileChange($event):upload(file.files)" accept="{{ '.xls,.xlsx,.csv' }}" /> -->
      <div class="btncommon selectfile" id="btnfileUploadselctfile">Select File</div>
    </label>

  </div>
  <span style="font-weight:bold;color:green;" *ngIf="message">
    {{message}}
  </span>
</div>